/**
 * Lenis smooth scroll for storefront.
 * Keep native scroll if reduced-motion / theme editor.
 * Do NOT put data-lenis-prevent on closed drawers — fixed overlays
 * would swallow wheel events and lock page scroll.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  // Native scroll on touch / iOS — Lenis + fixed header often drifts in Safari
  var isTouchUi =
    window.matchMedia('(hover: none) and (pointer: coarse)').matches ||
    /iPhone|iPad|iPod/i.test(navigator.userAgent || '');
  if (isTouchUi) return;

  var lenis = new Lenis({
    duration: 1.05,
    easing: function (t) {
      return Math.min(1, 1.001 - Math.pow(2, -10 * t));
    },
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    wheelMultiplier: 0.9,
    touchMultiplier: 1,
    syncTouch: false,
    infinite: false,
    autoResize: true,
    // Only skip Lenis when the event target is inside an open overlay
    // (also check shadow host so ::part scroll areas match x-modal / x-popover)
    prevent: function (node) {
      function isOverlay(el) {
        if (!el || !el.closest) return false;
        return !!el.closest(
          'cart-drawer[open], header-menu-drawer[open], #menu-dropdown-sidebar[open], dialog[open], .drawer[open], x-modal[open], .modal[open], x-popover[open], .popover[open], .pswp--open, [data-lenis-prevent]'
        );
      }
      if (isOverlay(node)) return true;
      if (node && node.getRootNode) {
        var root = node.getRootNode();
        if (root && root.host && isOverlay(root.host)) return true;
      }
      return false;
    },
  });

  window.__lenis = lenis;

  var rafId = requestAnimationFrame(function raf(time) {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  });

  function anyOverlayOpen() {
    return !!document.querySelector(
      'cart-drawer[open], header-menu-drawer[open], #menu-dropdown-sidebar[open], dialog[open], .drawer[open], x-modal[open], .modal[open], x-popover[open], .popover[open], .pswp--open'
    );
  }

  function syncLenisState() {
    if (anyOverlayOpen()) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }

  // Keep wheel scrolling inside open popover lists (country/locale) — Lenis/page must not steal it
  document.addEventListener(
    'wheel',
    function (event) {
      var list = event.target && event.target.closest && event.target.closest('.popover__value-list');
      if (!list) {
        var host =
          event.target && event.target.closest
            ? event.target.closest('x-popover[open], .popover[open]')
            : null;
        if (!host && event.target && event.target.getRootNode) {
          var root = event.target.getRootNode();
          if (root && root.host && root.host.matches && root.host.matches('x-popover[open], .popover[open]')) {
            host = root.host;
          }
        }
        if (host) {
          list = host.querySelector('.popover__value-list');
        }
      }
      if (!list) return;

      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var canScroll = list.scrollHeight > list.clientHeight + 1;
      if (!canScroll) return;

      var atTop = list.scrollTop <= 0;
      var atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
      if ((event.deltaY < 0 && atTop) || (event.deltaY > 0 && atBottom)) {
        event.preventDefault();
        return;
      }

      // Native scroll on the list; block page/Lenis from also moving
      event.preventDefault();
      list.scrollTop += event.deltaY;
    },
    { capture: true, passive: false }
  );

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'open') {
        syncLenisState();
        return;
      }
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['open'],
  });

  document.addEventListener('click', function (event) {
    var anchor = event.target.closest('a[href^="#"]');
    if (!anchor) return;
    var href = anchor.getAttribute('href');
    if (!href || href === '#' || href === '#main') return;
    if (anchor.hasAttribute('allow-hash-change') || anchor.hasAttribute('data-no-lenis')) return;

    var target = document.getElementById(decodeURIComponent(href.slice(1)));
    if (!target) return;

    event.preventDefault();
    lenis.scrollTo(target, { offset: -20 });
  });

  window.addEventListener(
    'pagehide',
    function () {
      cancelAnimationFrame(rafId);
      observer.disconnect();
      try {
        lenis.destroy();
      } catch (e) {}
      window.__lenis = null;
    },
    { once: true }
  );

  syncLenisState();
})();
